/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardTypeConsentEntity,
    CardTypeConsentEntityFromJSON,
    CardTypeConsentEntityFromJSONTyped,
    CardTypeConsentEntityToJSON,
} from './CardTypeConsentEntity';

/**
 * 
 * @export
 * @interface ReadConsentOptOutEntity
 */
export interface ReadConsentOptOutEntity {
    /**
     * 
     * @type {string}
     * @memberof ReadConsentOptOutEntity
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReadConsentOptOutEntity
     */
    readConsentOptOut?: boolean;
    /**
     * 
     * @type {CardTypeConsentEntity}
     * @memberof ReadConsentOptOutEntity
     */
    cardTypeConsent?: CardTypeConsentEntity;
}

export function ReadConsentOptOutEntityFromJSON(json: any): ReadConsentOptOutEntity {
    return ReadConsentOptOutEntityFromJSONTyped(json, false);
}

export function ReadConsentOptOutEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadConsentOptOutEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'readConsentOptOut': !exists(json, 'readConsentOptOut') ? undefined : json['readConsentOptOut'],
        'cardTypeConsent': !exists(json, 'cardTypeConsent') ? undefined : CardTypeConsentEntityFromJSON(json['cardTypeConsent']),
    };
}

export function ReadConsentOptOutEntityToJSON(value?: ReadConsentOptOutEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'readConsentOptOut': value.readConsentOptOut,
        'cardTypeConsent': CardTypeConsentEntityToJSON(value.cardTypeConsent),
    };
}

